// extracted by mini-css-extract-plugin
export default {"container":"form-group_container__1c71q","label":"form-group_label__3G5mE"};